import { colorSystem, Tooltip } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import { StarIcon } from 'lucide-react';

import {
    PreferredTag,
    PreferredTagEnum,
    preferredTagTooltipTranslations,
    preferredTagTranslations,
} from './PreferredTag';

export const PreferredManufacturerTagWithText = ({
    size = 'large',
    showTooltip = false,
}: {
    size?: 'small' | 'large';
    showTooltip?: boolean;
}): JSX.Element => {
    return (
        <PreferredTag
            label={size === 'large' ? transEnum(PreferredTagEnum.Manufacturer, preferredTagTranslations) : undefined}
            tooltip={showTooltip ? transEnum(PreferredTagEnum.Manufacturer, preferredTagTooltipTranslations) : ''}
        />
    );
};

export const PreferredManufacturerTag = ({ showTooltip = true }: { showTooltip?: boolean }): JSX.Element => {
    return (
        <Tooltip title={showTooltip ? transEnum(PreferredTagEnum.Manufacturer, preferredTagTooltipTranslations) : ''}>
            <StarIcon size={16} color={colorSystem.primary[7]} aria-hidden fill={colorSystem.primary[7]} />
        </Tooltip>
    );
};
